import { render, staticRenderFns } from "./PodsInput.vue?vue&type=template&id=15695398&scoped=true&"
import script from "./PodsInput.vue?vue&type=script&lang=js&"
export * from "./PodsInput.vue?vue&type=script&lang=js&"
import style0 from "./PodsInput.vue?vue&type=style&index=0&id=15695398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15695398",
  null
  
)

export default component.exports